export default __webpack_public_path__ + "static/media/ekaterinburg.ccc40197.pdf";